import { render, staticRenderFns } from "./MetaIcon.vue?vue&type=template&id=be890aa6&"
import script from "./MetaIcon.vue?vue&type=script&lang=js&"
export * from "./MetaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports